// extracted by mini-css-extract-plugin
export default {"root":"UserAvatar_root__tJQs8","avatar":"UserAvatar_avatar__PRuXG","avatarEdit":"UserAvatar_avatarEdit__hrLZS","avatarInput":"UserAvatar_avatarInput__3qdZn"};